/**
 * ConditionalEdgeButton - Diamond-shaped button for conditional edges
 * 
 * Displays on conditional edges and opens the code editor when clicked
 */

import React from 'react';
import { EdgeLabelRenderer, BaseEdge, getBezierPath } from 'reactflow';
import './ConditionalEdgeButton.css';

export const ConditionalEdgeButton = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  label,
  data,
  onClick
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick(e, { id, data });
    }
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            pointerEvents: 'all',
          }}
          className="conditional-edge-button-wrapper"
        >
          <button
            className="conditional-edge-button"
            onClick={handleClick}
            title="Click to edit conditional logic"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" className="diamond-icon">
              <path
                d="M12 2 L22 12 L12 22 L2 12 Z"
                fill="currentColor"
                stroke="none"
              />
              <text
                x="12"
                y="15"
                textAnchor="middle"
                fill="white"
                fontSize="10"
                fontWeight="bold"
              >
                ?
              </text>
            </svg>
          </button>
          {label && (
            <div className="conditional-edge-label">
              {label}
            </div>
          )}
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

/**
 * Custom edge component for React Flow
 * Used to render conditional edges with diamond button
 */
export const ConditionalEdge = (props) => {
  return <ConditionalEdgeButton {...props} />;
};
